// react
import { useRef, useEffect, useState } from 'react'

// types
import { RequestConsiderDocType, RequestConsiderDocViewType } from './requestConsiderDoc'
import { GetProjectResultType } from '../../../../../services/web/types/responseWebServiceTypes'
import * as appFolderAndTabStoreType from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'

// constants
import * as Constants from '../../../../../constants/constants'
import constSubmittedType from '../../../../../constants/submittedType'
import constSubmittedStep from '../../../../../constants/submittedStep'

// services
import useWebService from '../../../../../services/web/useWebService'
import useLookupService from '../../../../../services/lookup/useLookupService'

// stores
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../stores/manageProject/useManageProjectAction'
import useAuthenStore from '../../../../../stores/authen/authenStore'

// control & hooks
import useLoading from '../../../../../control/loading/useLoading'
import useTranslate from '../../../../../i18n/useTranslate'

const useSubmitDocConsider = (props: RequestConsiderDocType) => {
    const { bindRef } = props

    const [lstOption, setLSTOption] = useState<any>([])

    const dialogRef = useRef<{ open: Function; close: Function }>()
    const authenStore = useAuthenStore()
    const loadingHook = useLoading()
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()
    const translate = useTranslate()

    const callWebService = useWebService()
    const callLookupService = useLookupService()

    useEffect(() => {
        loadLookupRequestConsiderDoc()
    }, [
        manageProjectStore?.projectData?.projectID,
        manageProjectStore?.projectData?.projectStatusInfo?.value,
        translate.languageStore.currentLanguage,
    ])

    const loadLookupRequestConsiderDoc = async () => {
        try {
            loadingHook.loadingOpen()
            const userGroupID = authenStore?.profile?.userGroupId
            const projectID = manageProjectStore?.projectData?.projectID

            if (userGroupID && projectID) {
                const res = await callLookupService.getRequestConsiderDoc(userGroupID, projectID)
                const formatLookup = res.result.map((itm) => {
                    return {
                        label:
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.name_th
                                : itm.name_en,
                        value: `${itm.id}`,
                        description: translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.name_th
                                : itm.name_en,
                    }
                })
                setLSTOption(formatLookup)
            }
            loadingHook.loadingClose()
        } catch (ex) {
        } finally {
            loadingHook.loadingClose()
        }
    }

    //* ขอปิดโครงการ
    const createFolderCloseProject = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            { ...Constants.customFolder.closeProject, isLastProcess: true },
            ...appFolderAndTabStore.folderList.map((itm) => ({ ...itm, isLastProcess: false })),
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.closeProject,
                    nameTH: Constants.customFolder.closeProject.folderName_th,
                    nameEN: Constants.customFolder.closeProject.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: Constants.customFolder.closeProject,
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
                tabIndexSelected: 0,
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* โครงการระยะถัดไป
    const createFolderNextPhaseProject = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.projectPhase,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null

            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.nextPhaseProject,
                    nameTH: Constants.customFolder.projectPhase.folderName_th,
                    nameEN: Constants.customFolder.projectPhase.folderName_en,
                },
            }

            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.projectPhase,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    const createFolderReportedAdverseEventsProject = async () => {
        //เหตุการณ์ไม่เป็นไปตามข้อกำหนด
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.raeProject,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.nonconformance,
                    nameTH: Constants.customFolder.raeProject.folderName_th,
                    nameEN: Constants.customFolder.raeProject.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: Constants.customFolder.raeProject,
                tabSelected: Constants.menuTab.tab1,
                tabRenderList: [Constants.menuTab.tab1],
                tabIndexSelected: 0,
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* ขอแก้ไขโครงการหลังได้รับอนุมัติ (Amendment)
    const createFolderProjectAmendment = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.projectAmendment,
                isLastProcess: true,
            },
            ...folderList,
        ]
        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null

            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.amendmentProject,
                    nameTH: Constants.customFolder.projectAmendment.folderName_th,
                    nameEN: Constants.customFolder.projectAmendment.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.projectAmendment,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* ขอต่ออายุโครงการ
    const createFolderProjectRenewal = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.projectRenewal,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.renewalProject,
                    nameTH: Constants.customFolder.projectRenewal.folderName_th,
                    nameEN: Constants.customFolder.projectRenewal.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.projectRenewal,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    //* ขอยุติโครงการ
    const createFolderTerminateProject = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.terminateProject,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.terminateProject,
                    nameTH: Constants.customFolder.terminateProject.folderName_th,
                    nameEN: Constants.customFolder.terminateProject.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.terminateProject,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    //* รายงานเหตุการณ์ที่ไม่พึงประสงค์
    const createFolderAdverseEvents = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.adverseEvents,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.adverseEvent,
                    nameTH: Constants.customFolder.adverseEvents.folderName_th,
                    nameEN: Constants.customFolder.adverseEvents.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.adverseEvents,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    const createFolderCloseProjectByAdmin = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.closeProjectByAdmin,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.closeProjectByAdmin,
                    nameTH: Constants.customFolder.closeProjectByAdmin.folderName_th,
                    nameEN: Constants.customFolder.closeProjectByAdmin.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: Constants.customFolder.closeProjectByAdmin,
                tabSelected: Constants.menuTab.tab1,
                tabRenderList: [Constants.menuTab.tab1],
                tabIndexSelected: 0,
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    const createFolderTerminateProjectByAdmin = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.terminateProjectByAdmin,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.terminateProjectByAdmin,
                    nameTH: Constants.customFolder.terminateProjectByAdmin.folderName_th,
                    nameEN: Constants.customFolder.terminateProjectByAdmin.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: Constants.customFolder.terminateProjectByAdmin,
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
                tabIndexSelected: 0,
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* ขอถอนโครงการ
    const createFolderWithdrawProject = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            { ...Constants.customFolder.withdrawProject, isLastProcess: true },
            ...appFolderAndTabStore.folderList.map((itm) => ({ ...itm, isLastProcess: false })),
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.withdrawalProject,
                    nameTH: Constants.customFolder.withdrawProject.folderName_th,
                    nameEN: Constants.customFolder.withdrawProject.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            //SetFolder
            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
            //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: Constants.customFolder.withdrawProject,
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
                tabIndexSelected: 0,
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* ขอแก้ไขพร้อมต่ออายุโครงการ
    const createRenewAndAmendmentProject = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.renewalAndAmendmentProject,
                isLastProcess: true,
            },
            ...folderList,
        ]
        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
            let customResult: Partial<GetProjectResultType> | null = null

            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.renewalAndAmendmentProject,
                    nameTH: Constants.customFolder.renewalAndAmendmentProject.folderName_th,
                    nameEN: Constants.customFolder.renewalAndAmendmentProject.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.renewalAndAmendmentProject,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }

        dialogRef.current?.close()
    }

    //* รายงานความก้าวหน้าโครงการที่มีความเสี่ยงสูง
    const createHighRiskProjectProgressReport = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.highRiskProjectProgressReport,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.highRiskProjectProgressReport,
                    nameTH: Constants.customFolder.highRiskProjectProgressReport.folderName_th,
                    nameEN: Constants.customFolder.highRiskProjectProgressReport.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.highRiskProjectProgressReport,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    //* เอกสารสำหรับตรวจเยี่ยม
    const createInspectionDocuments = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]

        const folderList = appFolderAndTabStore.folderList.map((itm) => ({
            ...itm,
            isLastProcess: false,
        }))

        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            {
                ...Constants.customFolder.projectSiteVisit,
                isLastProcess: true,
            },
            ...folderList,
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)

            let customResult: Partial<GetProjectResultType> | null = null
            customResult = {
                ...result,
                submittedID: undefined,
                stepID: constSubmittedStep.submit,
                latestDocument: [],
                documentInfo: [],
                documentAdditionalInfo: [],
                isFlowApproveWithComment: false,
                synthesisApproveStatusInfo: undefined,
                submitTypeInfo: {
                    value: constSubmittedType.projectSiteVisit,
                    nameTH: Constants.customFolder.projectSiteVisit.folderName_th,
                    nameEN: Constants.customFolder.projectSiteVisit.folderName_en,
                },
            }
            manageProjectAction.setProjectData(customResult as GetProjectResultType)

            const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)

            appFolderAndTabAction.setState({
                folderList: folder,
                folderSelected: {
                    ...Constants.customFolder.projectSiteVisit,
                },
                tabSelected: Constants.menuTab.tab21,
                tabRenderList: [Constants.menuTab.tab21],
            })
            loadingHook.loadingClose()
        }
        dialogRef.current?.close()
    }

    const handleRefDialog = (fn: Record<string, Function>) => {
        dialogRef.current = {
            open: fn?.openDialog,
            close: fn?.closeDialog,
        }
        bindRef.current = dialogRef.current
    }

    const handleClickSave = (param: any) => {
        const submitTypeID: number = Number(param.projectSubmitType.value)
        switch (submitTypeID) {
            case constSubmittedType.closeProject:
                createFolderCloseProject()
                break
            case constSubmittedType.amendmentProject:
                createFolderProjectAmendment()
                break
            case constSubmittedType.nextPhaseProject:
                createFolderNextPhaseProject()
                break
            case constSubmittedType.nonconformance:
                createFolderReportedAdverseEventsProject()
                break
            case constSubmittedType.renewalProject:
                createFolderProjectRenewal()
                break
            case constSubmittedType.terminateProject:
                createFolderTerminateProject()
                break
            case constSubmittedType.adverseEvent:
                createFolderAdverseEvents()
                break
            case constSubmittedType.terminateProjectByAdmin:
                createFolderTerminateProjectByAdmin()
                break
            case constSubmittedType.closeProjectByAdmin:
                createFolderCloseProjectByAdmin()
                break
            case constSubmittedType.withdrawalProject:
                createFolderWithdrawProject()
                break
            case constSubmittedType.renewalAndAmendmentProject:
                createRenewAndAmendmentProject()
                break
            case constSubmittedType.highRiskProjectProgressReport:
                createHighRiskProjectProgressReport()
                break
            case constSubmittedType.projectSiteVisit:
                createInspectionDocuments()
                break
            default:
                break
        }
    }

    const handleClickClose = () => {
        dialogRef.current?.close()
    }

    return {
        lstOption: lstOption,
        onRefDialog: handleRefDialog,
        onClickClose: handleClickClose,
        onClickSave: handleClickSave,
    }
}

export default useSubmitDocConsider
